import React from 'react';
import { Box, SxProps, useTheme } from '@mui/material';

const statusIndicator: SxProps = {
  borderRadius: '50%',
  display: 'inline-block',
  animation: 'pulse 1.5s infinite'
};

type Props = {
  color?: string;
  size?: number;
};

export const PulsingDot: React.FC<Props> = ({ color, size }) => {
  const { palette } = useTheme();

  return (
    <Box
      sx={{
        ...statusIndicator,
        backgroundColor: !color ? palette.success.dark : color,
        width: !size ? 12 : size,
        height: !size ? 12 : size
      }}
    />
  );
};
